import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"down-top-padding",attrs:{"fluid":""}},[_c('BaseBreadcrumb',{attrs:{"title":_vm.page.title,"module_name":_vm.page.name}}),_c(VRow,[_c(VCol,[_c('base-table',{ref:"base_table",attrs:{"page":_vm.page},on:{"create":_vm.create,"edit":_vm.edit}})],1)],1),_c('create-exam',{ref:"create_exam",attrs:{"modal_name":"create_exam"},on:{"refresh":_vm.reload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }